import type { SVGProps } from 'react';
const DawnFlagTO = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-TO_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-TO_svg__a)">
      <path fill="#E20F1B" d="M22 0h-9.429v8.533H0V16h22z" />
      <path
        fill="url(#dawn-flag-TO_svg__b)"
        d="M5.571 1.067a.333.333 0 0 0-.333.333v1.8H3.476a.333.333 0 0 0-.333.333V5c0 .184.149.333.333.333h1.762v1.8c0 .184.149.334.333.334H7c.184 0 .333-.15.333-.334v-1.8h1.762c.184 0 .333-.149.333-.333V3.533a.333.333 0 0 0-.333-.333H7.333V1.4A.333.333 0 0 0 7 1.067z"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-TO_svg__b"
        x1={3.143}
        x2={3.143}
        y1={1.067}
        y2={7.467}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DF101B" />
        <stop offset={1} stopColor="#C00711" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagTO;
